import { RolodexEntryJson } from 'types/rolodex/rolodexEntries'
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

export class GeckoSiteAssetHierarchy extends GeckoEntryBase<
  {
    root_nodes: number
    total_assets: number
    maximum_depth: number
  },
  {
    site: string
    organization: string
  }
> {
  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        root_nodes: parseNumber(json.data.root_nodes) ?? 0,
        total_assets: parseNumber(json.data.total_assets) ?? 0,
        maximum_depth: parseNumber(json.data.maximum_depth) ?? 0,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  /**
   * A simple factory method which creates a site asset hierarchy from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoSiteAssetHierarchy(json)
  }
}
